import { render, staticRenderFns } from "./NavbarClassroomIcon.vue?vue&type=template&id=b21746a6&"
import script from "./NavbarClassroomIcon.vue?vue&type=script&lang=ts&"
export * from "./NavbarClassroomIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b21746a6', component.options)
    } else {
      api.reload('b21746a6', component.options)
    }
    module.hot.accept("./NavbarClassroomIcon.vue?vue&type=template&id=b21746a6&", function () {
      api.rerender('b21746a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/icons/NavbarClassroomIcon.vue"
export default component.exports